import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo-black.png'


const _hoisted_1 = {
  class: "tab-pane fade in active show",
  id: "members",
  style: {"overflow-x":"auto"}
}
const _hoisted_2 = {
  ref: "refLogo",
  src: _imports_0,
  alt: "store",
  style: {"display":"none"}
}
const _hoisted_3 = {
  key: 1,
  class: "datatables table table-striped table-bordered"
}
const _hoisted_4 = { class: "thead-dark" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fw-bold text-dark" }
const _hoisted_11 = { class: "text-muted fw-bold small" }
const _hoisted_12 = {
  key: 0,
  class: "text-secondary small mt-1"
}
const _hoisted_13 = { class: "fw-semibold" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "badge bg-success text-black px-2 py-1",
  title: "C'est le tout premier abonnement de ce membre"
}
const _hoisted_16 = {
  key: 1,
  class: "badge bg-primary text-white px-2 py-1",
  title: "Ce membre a renouvelé exactement le même pack que son abonnement précédent"
}
const _hoisted_17 = {
  key: 2,
  class: "badge bg-warning text-dark px-2 py-1",
  title: "Ce membre a changé de pack par rapport à son abonnement précédent"
}
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_element_per_page = _resolveComponent("element-per-page")!
  const _component_member_route = _resolveComponent("member-route")!
  const _component_element_is_paid = _resolveComponent("element-is-paid")!
  const _component_element_status_subscription = _resolveComponent("element-status-subscription")!
  const _component_btn_default = _resolveComponent("btn-default")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_member_contract = _resolveComponent("member-contract")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRequestSubscription)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_element_per_page),
    _createElementVNode("img", _hoisted_2, null, 512),
    (_ctx.subscriptionMembers && _ctx.subscriptionMembers?.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", null, [
              (!_ctx.isMember)
                ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString(_ctx.i18n.t('tables.members.matricule')), 1))
                : _createCommentVNode("", true),
              (!_ctx.isMember)
                ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.i18n.t('tables.members.name')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.members.contractNumber')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.title')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.created_at')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.start_date')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.end_date')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.total_amount')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.total_amount_paid')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_amount')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.payment_status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_days')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionMembers, (subscription) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: subscription.id
              }, [
                (!_ctx.isMember)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                      (_ctx.hasPermission('fiche_member'))
                        ? (_openBlock(), _createBlock(_component_member_route, {
                            key: 0,
                            memberUUID: _ctx.isMember ? _ctx.member?.uuid : subscription?.member_info?.uuid,
                            matricule: _ctx.isMember ? _ctx.member?.matricule : subscription?.member_info?.matricule
                          }, null, 8, ["memberUUID", "matricule"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.isMember ? _ctx.member?.matricule : subscription?.member_info?.matricule), 1))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isMember)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.isMember ? _ctx.member?.matricule : subscription?.member_info?.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(subscription?.contractNumber ?? ''), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(subscription?.subscription?.name), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(subscription?.pack?.name), 1),
                  (subscription?.parent_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.i18n.t('status.subscription_holder')) + ":", 1),
                        _createElementVNode("span", null, _toDisplayString(subscription?.parent_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    (!subscription.is_renewal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " ✨ Premier Abonnement "))
                      : (subscription.is_same_prev_pack)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 🔄 Même pack (Précédent) "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, " 🔀 Changement (vs Précédent) "))
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(subscription.created_at)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(subscription.start_date)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(subscription.end_date)), 1),
                _createElementVNode("td", null, _toDisplayString(subscription?.total_amount ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                _createElementVNode("td", null, _toDisplayString(subscription?.total_amount_paid ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                _createElementVNode("td", null, _toDisplayString(subscription?.remaining_amount ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_element_is_paid, {
                    remaining_amount: subscription?.remaining_amount
                  }, null, 8, ["remaining_amount"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_element_status_subscription, { subscription: subscription }, null, 8, ["subscription"])
                ]),
                _createElementVNode("td", null, [
                  (_ctx.hasPermission('impayes'))
                    ? (_openBlock(), _createBlock(_component_btn_default, {
                        key: 0,
                        btnClass: `btn btn-show m-1`,
                        onDefault: ($event: any) => (_ctx.redirectTo({ name: 'impayes', params: { subscriptionID: subscription?.id, clubUUID: _ctx.clubUUID, memberUUID: _ctx.isMember ? _ctx.member?.uuid : subscription?.member_info?.uuid } })),
                        icon: "eye",
                        tooltip: _ctx.i18n.t('button.details')
                      }, null, 8, ["onDefault", "tooltip"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('delete_member_subscription'))
                    ? (_openBlock(), _createBlock(_component_btn_delete, {
                        key: 1,
                        onDelete: ($event: any) => (_ctx.deleteSubscriptionMember(subscription?.id))
                      }, null, 8, ["onDelete"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('download_contract') && _ctx.contract)
                    ? (_openBlock(), _createBlock(_component_member_contract, {
                        "show-text": false,
                        classes: "btn btn-file m-1",
                        member: _ctx.isMember ? _ctx.member : subscription?.member_info,
                        subscription: subscription,
                        key: subscription.id
                      }, null, 8, ["member", "subscription"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('download_invoice') && _ctx.invoice)
                    ? (_openBlock(), _createBlock(_component_btn_default, {
                        key: 3,
                        btnClass: `btn btn-file m-1`,
                        onDefault: ($event: any) => (_ctx.exportInvoice(_ctx.isMember ? _ctx.member : subscription?.member_info, subscription)),
                        icon: "file-invoice",
                        tooltip: _ctx.i18n.t('button.download', { title: 'facture' })
                      }, null, 8, ["onDefault", "tooltip"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('extend_subscriptions'))
                    ? (_openBlock(), _createBlock(_component_btn_default, {
                        key: 4,
                        btnClass: `btn btn-success m-1`,
                        onDefault: ($event: any) => (_ctx.redirectTo({
                                name: 'update-datefin',
                                params: {
                                    clubUUID: _ctx.clubUUID,
                                    memberUUID: subscription?.member_info?.uuid,
                                    subscriptionID: subscription?.id,
                                },
                            })),
                        icon: "calendar-plus",
                        tooltip: _ctx.i18n.t('button.update_date_fin')
                      }, null, 8, ["onDefault", "tooltip"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_not_found, {
            text: _ctx.i18n.t('message.data_not_found.title'),
            icon: "warning"
          }, null, 8, ["text"])
        ]))
  ]))
}